import { createSharedComposable } from '@vueuse/core'
import { useUserStore } from '@/pinia/user'
import { useCalcShip } from './useCalcShip'

// 查询是否允许下单
export const useOrderEnable = createSharedComposable(() => {
  const user = useUserStore()

  const { shippingConfirmed } = useCalcShip()

  const enable = computed(() => !user.isLogged || user.userInfo.allowOrderSwitch === 1 || shippingConfirmed.value)

  onBeforeMount(() => {
    if (user.isLogged) {
      user.initUserAllowOrderStatus()
    }
  })

  watch(() => user.isLogged, (isLogged) => {
    if (isLogged) {
      user.initUserAllowOrderStatus()
    }
  })

  return {
    enable
  }
})
